module.exports = __webpack_public_path__ + "static/media/image.108f2513.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/The2020ChangesToFacebooksAlgorithm/image.jpg
// module id = 77
// module chunks = 0